export const environment = {
  production: true,
  urlApi: 'https://test.api.operaciones.maltia.cleversecdesarrollo.app:5703/api',
  // urlApi: 'https://localhost:44380/api',
  google: {
    gaApiKey: 'AW-11197307083'
  },
  chatwoot: {
    baseUrl: 'https://chatwoot.cleversec.com.mx',
    websiteToken: 'DZDv5b5i872bCw32mAAMFx1W'
  }
};

// http://localhost:4200/apply-for-credit/upload-ine-front?folio=1131&nip=1QAHX